export const HEADER = 'Ready to get to action?';
export const FOOTER_TEXT = 'get in touch with us';
